<template>
  <b-container class="p-3" fluid>
    <b-row>
      <b-col>
        <b-card class="mb-4">
          <div class="ml-auto">
            <b-button v-b-modal.add-year-modal variant="primary">
              <font-awesome-icon icon="plus-circle" />เพิ่มปีการศึกษา
            </b-button>
          </div>
        </b-card>

        <ac-year-list-table :years="acYears.data" />

        <add-ac-year-modal @finish="refetch" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AcYearListTable from '@/components/settings/ac-years/AcYearListTable'
import AddAcYearModal from '@/components/settings/ac-years/AddAcYearModal'

import gql from 'graphql-tag'

export default {
  apollo: {
    acYears: {
      query: gql`{ acYears(page:1, count:100) { data { id, year, startAt, endAt } } }`,
      fetchPolicy: 'no-cache'
    }
  },
  components: {
    AcYearListTable, AddAcYearModal
  },
  data () {
    return {
      acYears: {
        data: []
      }
    }
  },
  methods: {
    refetch () {
      this.$apollo.queries.acYears.refetch()
    }
  }
}
</script>
